import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames/bind';
import { Defaults } from 'app/lib/constants';
import { LinkButton } from 'app/components/core/LinkButton';
import * as styles from './ConnectionLostOverlay.css';

let timer = null;

const cx = classnames.bind(styles);

const DEFAULT_STATUS = { isConnected: true };

export const ConnectionLostOverlay = ({
    onReconnect = Defaults.NOOP,
    status = DEFAULT_STATUS,
    failedServices = Defaults.ARRAY,
    isAllFailed = false
}) => {
    const { isConnected, nextRetry } = status;
    const [seconds, setSeconds] = useState(0);

    const { t } = useTranslation();

    useEffect(() => {
        if (timer) {
            clearInterval(timer);
        }

        if (!isConnected && nextRetry) {
            const update = (seconds) =>
                setSeconds(seconds === 0 ? 0 : Math.ceil((seconds - Date.now()) / 1000));

            update(nextRetry);

            timer = setInterval(() => {
                update(nextRetry);
            }, 1000);
        }

        return () => timer && clearInterval(timer);
    }, [isConnected, nextRetry]);

    if (isConnected) {
        return null;
    }

    let messageClass = 'error';
    let errorMsg = t('errors:Websocket.lostConnection', { seconds });
    if (!isAllFailed) {
        messageClass = 'warning';
        const notRunningStr = failedServices?.join(',');
        errorMsg = t('errors:Websocket.serviceFailed', { service: notRunningStr });
    }

    return (
        <div className={styles.base}>
            <div className={cx(styles.overlay, messageClass)}>
                <div className={styles.banner}>
                    {errorMsg}{' '}
                    {isAllFailed && (
                        <LinkButton underline colorless onClick={onReconnect}>
                            {t('errors:Websocket.retry')}
                        </LinkButton>
                    )}
                </div>
            </div>
        </div>
    );
};

ConnectionLostOverlay.propTypes = {
    onReconnect: PropTypes.func,
    isAllFailed: PropTypes.bool,
    failedServices: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.shape({
        isConnected: PropTypes.bool,
        nextRetry: PropTypes.number
    })
};
